import { SURVEY, OPEN_POPUP } from '@/store/actions/survey'

export function getTextByType(type, type_seq, lang = 'ko') {
  let typeStr;
  if(lang.toLowerCase() === 'ko') {
    switch(type.toUpperCase()) {
      case 'E': typeStr = '단독사업자'; break;
      case 'P': typeStr = '공동사업자'; break;
      case 'S': typeStr = '배우자'; break;
      case 'F': typeStr = '가족'; break;
      default: typeStr = '기타';
    }
  } else {
    switch(type.toUpperCase()) {
      case 'E': typeStr = 'sole'; break;
      case 'P': typeStr = 'party'; break;
      case 'S': typeStr = 'spouse'; break;
      case 'F': typeStr = 'family'; break;
      default: typeStr = 'etc';
    }
  }
  return typeStr + (type_seq || '');
}

export default {
  methods: {
    getTextByType,
    openPopupLayer(payload) {
      this.$store.dispatch(`${SURVEY}/${OPEN_POPUP}`, payload);
    },
  }
}


// WEBPACK FOOTER //
// ./src/views/survey/mixins/CommonMethodMixin.js